import { useQuery } from "@apollo/client";
import { SalonReviewSource } from "@/gql/graphql";
import { SALON_REVIEW_STATS_QUERY } from "@/graphql/salon-reviews";
import { useSalonStore } from "@/lib/store/salon";

/**
 * Fetches aggregated review stats (avg rating, count, star distribution) for
 * the current salon. Pass `source` to scope to a single review surface —
 * GOOGLE for the Google Profile Page (GPA) page, MANUAL for the in-app
 * Platform page. Omit `source` for the combined overview card.
 *
 * The query is salon-scoped, so changing salons re-fetches automatically via
 * Apollo's variable change.
 */
export function useSalonReviewStats(source?: SalonReviewSource) {
  const { currentSalon } = useSalonStore();
  const salonId = currentSalon?.id;

  const { data, loading, error, refetch } = useQuery(SALON_REVIEW_STATS_QUERY, {
    variables: { salonId: salonId ?? "", input: { source: source ?? null } },
    skip: !salonId,
    errorPolicy: "all",
  });

  return {
    stats: data?.salonReviewStats ?? null,
    loading,
    error,
    refetch,
  };
}
